export default __webpack_public_path__ + "static/media/search-fail.cc0469cb.svg";